module.exports = __webpack_public_path__ + "assets/img/google.1968a74c.svg";